import type { RootState } from "reducers/store"

import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export const profileSlice = createSlice({
  initialState: {
    isLoggedIn: false,
  } as ProfileType,
  name: "profile",
  reducers: {
    signIn: (state, { payload }: PayloadAction<ProfileType>) => {
      const profile: ProfileType = {
        ...payload,
        isLoggedIn: true,
      }
      return profile
    },
    signOut: (state) => {
      const profile = { isLoggedIn: false } as ProfileType
      return profile
    },
    updatePermissions: (state, { payload: permissions }: PayloadAction<string[]>) => {
      return {
        ...state,
        permissions,
      }
    },
    updateUser: (state, { payload: user }: PayloadAction<User>) => {
      return {
        ...state,
        user,
      }
    },
  },
})

export const { signIn, signOut, updatePermissions, updateUser } = profileSlice.actions

export const profileSelector = ({ profile }: RootState) => profile
